  function handleCartRemove() {
    setTimeout(() => {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {

          // ✅ Force uncheck if cart is empty
        if (!cart.items || cart.items.length === 0) {
          document.querySelectorAll('.toggle_switch_button').forEach(toggle => {
            toggle.checked = false;
          });
        }


          const variantIdremove = '46134868082851';
          const isInCartremove = cart.items.some(item => item.id == variantIdremove);

           

          if (isInCartremove) {
            console.log("Item Founded");
          } else {
            console.log("Item not Founded");

            fetch('/cart/update.js?no_drawer=1', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                updates: {
                  46491772453027: 0,
                  46491776942243: 0
                }
              })
            })
            .then(response => response.json())
            .then(data => {
              // console.log('Both products removed:', data);
            })
            .catch(error => {
              // console.error('Error removing products:', error);
            });
          }
        })
        .catch(error => console.error('Error fetching cart:', error));
    }, 3000);
  }

  // Observe for dynamically added elements (cart drawer or buttons)
  const observer = new MutationObserver(() => {
    const removeButtons = document.querySelectorAll('.ast-cart__item__remove');
    removeButtons.forEach(button => {
      if (!button.dataset.listenerAdded) {
        button.dataset.listenerAdded = 'true';
        button.addEventListener('click', handleCartRemove);
      }
    });
  });

  // Start observing the whole document for new elements
  observer.observe(document.body, { childList: true, subtree: true });



  $(document).on("click", ".ast-cart__item__remove", function () {
    setTimeout(function () {
        var variantId =  $('#toggle_switch').attr('data-id');
        console.log("Helllo remove nutton click");
        console.log("variantId" + variantId);
        $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json', 
        success: function (cart) {
            arr = cart.items.filter(function(item){
                return item.id == variantId
            });
            if(arr.length){
                $('#toggle_switch').prop("checked",true);
            }else{
                $('#toggle_switch').prop("checked",false);
            }
        } 
        });
    }, 5000);
});

(function () {

  const params = new URLSearchParams(window.location.search);
  const campaign = params.get('utm_campaign');

  console.log('UTM Campaign:', campaign);

  if (!campaign || !campaign.includes('MAILZY')) return;

  const variantId = 46134868082851;

  if (sessionStorage.getItem('auto_add_done')) return;
  sessionStorage.setItem('auto_add_done', 'true');

  async function autoAdd(retry = 0) {
    try {
      const cart = await fetch('/cart.js', { cache: 'no-store' }).then(res => res.json());

      if (!cart || !cart.items) {
        throw new Error('Cart not ready');
      }

      const alreadyInCart = cart.items.some(item => item.id == variantId);

      if (!alreadyInCart) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            updates: {
              [variantId]: 1
            }
          })
        });

        console.log('Product silently added');
      }

    } catch (e) {
      console.warn('Retrying auto add...', retry);

      if (retry < 3) {
        setTimeout(() => autoAdd(retry + 1), 500);
      } else {
        console.error('Auto add failed after retries:', e);
      }
    }
  }

  // Wait for full page load + slight delay
  window.addEventListener('load', function () {
    setTimeout(() => autoAdd(), 300);
  });

})();


(function() {
  var SCRATCH_PATH = '/pages/completed-scratch-offs';
  var STORAGE_KEY = 'rivo_redirect_after_login';

  //Save ONLY if user is NOT logged in
  if (window.location.pathname.includes(SCRATCH_PATH)) {

    if (
      window.Rivo &&
      window.Rivo.common &&
      window.Rivo.common.customer
    ) {
      // Already logged in → do nothing
      sessionStorage.removeItem(STORAGE_KEY);
      return;
    }

    sessionStorage.setItem(STORAGE_KEY, SCRATCH_PATH);
    return;
  }

  //Check if redirect is pending
  var redirectUrl = sessionStorage.getItem(STORAGE_KEY);
  if (!redirectUrl) return;

  //Only redirect ONCE
  if (sessionStorage.getItem('rivo_redirect_done')) return;

  // Wait for Rivo
  var attempts = 0;
  var maxAttempts = 10;

  var interval = setInterval(function() {
    attempts++;

    if (
      window.Rivo &&
      window.Rivo.common &&
      window.Rivo.common.customer
    ) {
      clearInterval(interval);

      //Mark redirect done (prevents homepage redirect loop)
      sessionStorage.setItem('rivo_redirect_done', 'true');

      sessionStorage.removeItem(STORAGE_KEY);

      window.location.href = redirectUrl;
    }

    if (attempts >= maxAttempts) {
      clearInterval(interval);
    }

  }, 500);

})();

(function () {

  function getCookie(name) {
    const match = document.cookie.match(
      new RegExp('(^| )' + name + '=([^;]+)')
    );

    return match ? decodeURIComponent(match[2]) : null;
  }

  async function freeBagAutoAdd(retry = 0) {

    const discountCode = getCookie('discount_code');

    console.log('Discount Code:', discountCode);

    if (discountCode !== 'FREEBAG') return;

    const variantId = 47683724181667;

    try {

      const cart = await fetch('/cart.js', {
        cache: 'no-store'
      }).then(res => res.json());

      const alreadyInCart = cart.items.some(
        item => Number(item.variant_id) === Number(variantId)
      );

      if (alreadyInCart) {
        console.log('FREEBAG product already in cart');
        return;
      }

      // Add product
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      console.log('FREEBAG product added');

      document.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      document.dispatchEvent(new CustomEvent('cart:open', {
        bubbles: true
      }));

    } catch (e) {

      console.warn('Retrying FREEBAG add...', retry, e);

      if (retry < 5) {
        setTimeout(() => freeBagAutoAdd(retry + 1), 800);
      }
    }
  }

  // Run after popup verification
  window.addEventListener('cbdUserVerified', function () {
    setTimeout(() => {
      freeBagAutoAdd();
    }, 300);
  });

  // Also run immediately if already verified
  if (window.cbdUserData?.age_verified) {
    freeBagAutoAdd();
  }

})();